'use strict';

// Keep the same order as priceToggle

module.exports = {
  economicPenalty: 'economicPenalty',
  minMaxPenalty: 'minMaxPenalty',
  architecturePenalty: 'architecturePenalty',
  competitorPenalty: 'competitorPenalty',
  storeGroupPenalty: 'storeGroupPenalty',
  pricePointing: 'pricePointing',
};
